import { render, staticRenderFns } from "./ChannelInfo.vue?vue&type=template&id=fa88c0c2&scoped=true&lang=pug&"
import script from "./ChannelInfo.vue?vue&type=script&lang=js&"
export * from "./ChannelInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChannelInfo.vue?vue&type=style&index=0&id=fa88c0c2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa88c0c2",
  null
  
)

export default component.exports